<template>
  <div class="component-files">
    <!-- <div class="tips">上传实验等相关材料</div> -->
    <a href="javascript:;" ref="uploader">上传文件</a>
    <ul class="file-list" v-if="tempList.length > 0">
      <li v-for="(item, index) in tempList" :key="index">
        <i class="iconfont" :class="[fileIcon(item.url || item.key)]"></i>
        <div class="info">
          <div class="name">{{ item.name }}</div>
          <div class="actions">
            <div class="progress-warpper" v-if="item.percent">
              <div class="progress-bar">
                <div class="progress" :style="{ width: item.percent + '%' }"></div>
              </div>
              <span class="text">{{ item.percent }}%</span>
              <a href="javascript:;" @click="deleteFile(index)">取消</a>
            </div>
            <div class="completed" v-else>
              <a class="name" :href="item.url" target="_blank">查看</a>
              <a href="javascript:;" @click="deleteFile(index)">删除</a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Obs from "@/plugins/ulearning-obs.js";
import { API_HOST, RESOURCE_SERVER_HOST } from '@/config'
import { setObsConfig, fileIcon } from '@/utils/file.js'
import { mapGetters } from "vuex";
export default {
  props: ['list'],
  components: {
  },
  data() {
    return {
      tempList: []
    }
  },
  computed: {
    ...mapGetters({ user: 'user/user', token: "user/token" })
  },
  watch: {
    list: {
      handler(newVal) {
        this.tempList = newVal.map(item => {
          return {
            name: item.fileName,
            url: item.fileUrl
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    window.files = this
    let obs = new Obs(setObsConfig({
      uptokenHost: API_HOST,
      authorization: this.token,
      obsHost: RESOURCE_SERVER_HOST,
    }))
    obs.initUpBtn(this.$refs.uploader)
    obs.onBeforeUpload = (file) => {
      let temp = {
        name: file.name,
        size: file.size,
        percent: 0,
      }
      this.tempList.push(temp)
      file.onProgress = (percent) => {
        console.log('progress----file-----' + percent)
        temp.percent = percent
      }
      file.onSuccess = () => {
        console.log('success----file-----',file)
        temp.url = file.obsHost + '/' + file.key
        let fileList = this.tempList.filter(item => item.url).map(item => {
          return {
            fileName: item.name,
            fileUrl: item.url
          }
        })
        this.$emit('update', fileList)
      }
      file.onError = (err) => {
        console.log('error----file-----' + err)
      }
    }
  },
  methods: {
    fileIcon,
    deleteFile (i) {
      let list = this.tempList.filter(item => item.url).map(item => {
        return {
          fileName: item.name,
          fileUrl: item.url
        }
      })
      list.splice(i, 1)
      this.$emit('update', list)
    }
  }
}
</script>

<style lang="scss" scoped>
.tips{
  color: $--color-text-secondary;
  font-size: 12px;
  line-height: 1.5;
  margin: 10px 0;
}
.file-list{
  max-height: 230px;
  overflow: auto;
  padding: 12px  32px 12px 12px;
  background-color: $--background-color-base;
  li{
    display: flex;
    align-items: center;
    border-radius: 4px;
    &:not(:first-child){
      margin-top: 8px;
    }
    i{
      font-size: 36px;
    }
    .info{
      flex: 1;
      width: 0;
      margin-left: 10px;
      line-height: 20px;
    }
    .name{
      flex: 1;
      @include ellipsis;
    }
  }
  .actions{
    a{
      margin-right: 10px;
    }
  }
  .progress-warpper{
    display: flex;
    align-items: center;
    height: 20px;
    .progress-bar{
      width: 80px;
      height: 6px;
      background-color: $--color-text-placeholder;
      border-radius: 3px;
      overflow: hidden;
      margin-right: 10px;
      .progress{
        height: 100%;
        background-color: $--color-primary;
        transition: width 0.3s ease;
      }
    }
    .text{
      color: $--color-text-secondary;
      margin-right: 10px;
    }
  }
}
</style>